<template>
  <div
    class="field"
    style="margin:25px 0">
    <label
      for="file"
      class="label">Upload Files
      <input
        id="files"
        ref="files"
        type="file"
        multiple
        @change="selectFiles()">
    </label>
    <button @click="submitFiles()">Submit</button>
  </div>

</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  data: () => ({
    files: []
  }),

  methods: {
    selectFiles () {
      console.log('-- File Uploaded --')
      console.log(this.$refs.files.files)
      console.log('-------------------')
      this.files = this.$refs.files.files
    },
    submitFiles () {
      const formData = new FormData()
      console.log('-- FILES LENGTH --')
      console.log(this.files.length)
      console.log('------------------')

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        formData.append('files[' + i + ']', file)
      }

      console.log('-- final upload data --')
      console.log(formData)
    }
  }
}
</script>
<style lang="scss" scoped>
form {
     margin: 25px 0 25px 0
}
</style>
